import { Parameters, ServerEnvironment } from './src/api/config';
export const getMockedConfig = (): Parameters => ({
	'baseUrl': 'http://localhost:2222',
	'lpsUrl': 'https://testing-play.riseofcultures.com',
	'snippets': {
		'optional': [
			'<script>console.log("The tracking events have started...");setTimeout(function(){console.log("Tracking events are done.");}, 500);</script>'
		],
		'mandatory': [
			'<script>var innoSnippet = 44; console.log("test inno snippet: ", innoSnippet);</script>',
		],
	},
	'ipp': {
		'ippFbUrl': 'https://ipp-facebook.grepolis.com',
		'ippGoogleUrl': 'https://ipp-google.grepolis.com',
		'ippAppleUrl': 'https://ipp-staging-apple.innogames.de/?game=foe&market=xg',
	},
	'gameId': 'mobilecity',
	'marketId': 'us',
	'cdn': '',
	'bundle': '',
	'locale': 'en',
	'country' : 'DE',
	'landingPageId': '123',
	'partnerPrefix': 'gg',
	'campaignId': 'fac_nn_en_46\\\\81_43515_832636_4194\\-54079',
	'bannerId': '4194\\-54079',
	'creativeId': null,
	'publisherId': 'automatic',
	'backendRequestEventId': '0815',
	'social': {
		'facebook': 'https://www.facebook.com/riseofcultures',
		'youtube': 'https://www.youtube.com/channel/UCB_GE4eGNLNwZ8RG7Bmy5CA',
		'discord': 'https://discord.gg/QnPDw7Z68e',
	},
	'cdnUrlPrefix': '',
	'portalBar': {
		'html': '',
		'css': '',
		'js': 'https://portal-bar.innogames.de/js/de_DE/portal-bar.min.js',
	},
	'nickname': 'RememberMeNickname',
	'operatingSystem': 'TestOS',
	'deviceType': 'desktop',
	'isMobileRequest': true,
	'environment': ServerEnvironment.UNKNOWN,
	otherGames: {
		staemme: {
			url: 'https://tribalwars.wtf',
			gameId: 'staemme',
			name: 'Tribalwars'
		},
		grepo: {
			url: 'https://xx-play.grepolis.com',
			gameId: 'grepo',
			name: 'Grepolis'
		}
	},
	challengeConfig: {
		id: 'b7d1e19b-45b1-49c1-8dbc-d1116d7ba27d',
		timeout: 10000,
		challenge: 'dummychallenge',
		difficulty: 5,
		maxRetries: 10,
	}
	// Uncomment this for testing the ForgotPW token
	// 'forgotPw': {
	// 	'token': 'werew34reds',
	// 	'errorCode': '',
	// Uncomment this for testing the server error case
	// 'errorCode': 'passwordForgotten.genericServerError',
	// }
});
